import * as React from "react";
import { forwardRef } from "react";
const SvgEventCategoryChange = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	clipRule: "evenodd",
	d: "M30.5002 8.5c0 .8284-.6716 1.5-1.5 1.5h-27.5c-.8285 0-1.5-.6716-1.5-1.5S.6717 7 1.5002 7h27.5c.8284 0 1.5.6716 1.5 1.5ZM1.5002 23c0 .8284.6715 1.5 1.5 1.5h27.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5h-27.5c-.8285 0-1.5.6716-1.5 1.5Z",
	fill: "currentColor",
	fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
	clipRule: "evenodd",
	d: "M22.4583.4209c.5959-.5754 1.5455-.5588 2.121.0372l6.8323 7.0764c.6547.678.6547 1.753 0 2.431l-6.8323 7.0764c-.5755.596-1.5251.6126-2.121.0372-.596-.5754-.6127-1.525-.0372-2.121l5.994-6.2081-5.994-6.2081c-.5755-.596-.5588-1.5456.0372-2.121ZM10.0786 14.9575c-.5757-.5957-1.5253-.6118-2.121-.036l-7.314 7.0703c-.7117.6879-.7116 1.8285 0 2.5164l7.314 7.0703c.5957.5758 1.5453.5597 2.121-.036.5758-.5956.5597-1.5452-.0359-2.121L3.6584 23.25l6.3843-6.1715c.5956-.5758.6117-1.5254.0359-2.121Z",
	fill: "currentColor",
	fillRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgEventCategoryChange);
export default ForwardRef;
